import { DateTime } from 'luxon'

export const dateTimeFormatter = (nowDescription: string) => (date: DateTime) =>
  date <= DateTime.local() ? nowDescription : date.toLocaleString(DateTime.DATE_FULL)
